exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-en-tsx": () => import("./../../../src/pages/en.tsx" /* webpackChunkName: "component---src-pages-en-tsx" */),
  "component---src-pages-es-tsx": () => import("./../../../src/pages/es.tsx" /* webpackChunkName: "component---src-pages-es-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-legal-page-tsx": () => import("./../../../src/templates/LegalPage.tsx" /* webpackChunkName: "component---src-templates-legal-page-tsx" */)
}

